import React, { useState, useEffect } from 'react';
import { Card, Checkbox, Slider, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import Box from '@mui/material/Box';
import axios from 'axios';

import { BASE_URL } from '../apis/constant';
import { useFilterControl } from '../store/Store'; // Adjust the import path as needed

const ProductFilter = ({ onFilterChange }) => {
  const { appliedFilters, setFilters, resetFilters } = useFilterControl();
  
  const [priceRange, setPriceRange] = useState(appliedFilters.priceRange);
  const [selectedCategories, setSelectedCategories] = useState(appliedFilters.categories);
  const [allCategories, setAllCategories] = useState({ data: [], loading: false });



  // Sync with store when it changes
  useEffect(() => {
    setPriceRange(appliedFilters.priceRange);
    setSelectedCategories(appliedFilters.categories);
  }, [appliedFilters]);

  useEffect(() => {
    const fetchCategories = async () => {
      setAllCategories({ data: [], loading: true });

      try {
        const response = await axios.get(`${BASE_URL}/api/get_all_categories/`);

        const responseData = response.data;

        setAllCategories({
          data: responseData.data,
          loading: false
        });

      } catch (error) {
        console.error('Error fetching categories:', error);
        setAllCategories({
          data: [],
          loading: false
        });
        
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryChange = (categoryId, checked) => {
    const newSelectedCategories = checked
      ? [...selectedCategories, categoryId]
      : selectedCategories.filter(id => id !== categoryId);

    setSelectedCategories(newSelectedCategories);
    const updatedFilters = {
      categories: newSelectedCategories,
      priceRange: priceRange
    };
    
    setFilters(updatedFilters);
    applyFilters(updatedFilters);
  };

  const handlePriceChange = (value) => {
    setPriceRange(value);
    const updatedFilters = {
      categories: selectedCategories,
      priceRange: value
    };
    
    setFilters(updatedFilters);
    applyFilters(updatedFilters);
  };

  const applyFilters = (filters) => {
    onFilterChange?.(filters);
  };

  const clearAllFilters = () => {
    setSelectedCategories([]);
    setPriceRange([0, 5000]);
    resetFilters();
    onFilterChange?.({
      categories: [],
      priceRange: [0, 5000]
    });
  };

  return (
    <>
      <style>
        {`
          .custom-scrollbar::-webkit-scrollbar {
            width: 2px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: transparent;
            margin: 8px 0;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background-color: #ccc;
            border-radius: 1px;
          }
        `}
      </style>
      <Card
        bodyStyle={{ padding: '0' }}
        headStyle={{ padding: '0 12px' }}
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: '600' }}>
            <span>Filters</span>
            <Button
              type="text"
              size="small"
              icon={<ReloadOutlined />}
              onClick={clearAllFilters}
            >
              Reset
            </Button>
          </div>
        }
        style={{
          width: '100%',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}
      >
        <div className="custom-scrollbar"
          style={{
            maxHeight: 'calc(100vh - 150px)',
            overflowY: 'auto',
            padding: '0 8px'
          }}>
          {/* Price Range Section */}
          <div style={{
            padding: '12px 4px',
            borderBottom: '1px solid #f0f0f0'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '12px',
              fontWeight: '600',
              fontSize: '14px',
              padding: '0 4px'
            }}>
              <span>Price Range</span>
              <div style={{
                color: '#666',
                fontSize: '12px',
                fontWeight: '500'
              }}>
                <span style={{ fontSize: '16px', fontWeight: 'bolder' }}>৳</span>{priceRange[0]} - <span style={{ fontSize: '16px', fontWeight: 'bolder' }}>৳</span>{priceRange[1]}
              </div>
            </div>

            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30px' }} >
              <Slider
                range
                min={0}
                max={5000}
                step={50}
                value={priceRange}
                onChange={handlePriceChange}
                style={{ width: '88%' }}
              />
            </Box>
          </div>

          {/* Categories Section */}
          <div style={{
            padding: '12px 4px'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '12px',
              fontWeight: '600',
              fontSize: '14px',
              padding: '0 4px'
            }}>
              <span>Categories</span>
            </div>

            <div>
              {allCategories.data.map(category => (
                <div
                  key={category.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '6px 4px',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s'
                  }}
                  onClick={() => handleCategoryChange(
                    category.id,
                    !selectedCategories.includes(category.id)
                  )}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fafafa'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <Checkbox
                    checked={selectedCategories.includes(category.id)}
                    onChange={(e) => handleCategoryChange(category.id, e.target.checked)}
                  />
                  <span style={{
                    flex: 1,
                    marginLeft: '8px',
                    color: '#333',
                    fontSize: '13px'
                  }}>{category.name}</span>
                  <span style={{
                    color: '#999',
                    fontSize: '11px'
                  }}>{category.count}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default ProductFilter;